import {abilityFeature} from '../abilityFeature';

export const selectHasEntitlementsStore = (state: {
  EntitlementsStore?: unknown;
}) => Boolean(state.EntitlementsStore);

export const selectIsEntitlementsLoading = (state: {
  EntitlementsStore?: {isLoading?: boolean};
}) => state.EntitlementsStore?.isLoading ?? true;

export const selectHasEntitlementsError = (state: {
  EntitlementsStore?: {hasError?: boolean};
}) => state.EntitlementsStore?.hasError ?? false;

export const entitlements = abilityFeature({
  key: 'entitlements',
  isValid: function isEntitlementsValid(state, entitlementsToCheck) {
    if (!state.EntitlementsStore) return true;

    return entitlementsToCheck.every((entitlementKey) => {
      const entitlement =
        state.EntitlementsStore.entitlements?.[entitlementKey];
      if (!entitlement) return false;

      if (entitlement) {
        return entitlement.hasAccess;
      }

      return false;
    });
  },
});
